import AudioIconFile from "../../Icons/AudioFileIcon";
import * as React from "react";
import * as Player from "../../Icons/Player";

const AudioPreview = (props: {
  file: File;
  audioState: HTMLAudioElement;
  upPercentage?: number;
}) => {
  const { file, audioState, upPercentage } = props;

  const [percentage, setPercentage] = React.useState<number>(0);
  const [length, setLength] = React.useState<number>(0);

  const audioRef = React.useRef<HTMLAudioElement>(null);
  const [vol, setVol] = React.useState<number>(75);

  React.useEffect(() => {
    if (audioRef.current) {
      audioRef.current.volume = vol / 100;
    }
  }, [vol]);

  const [status, setStatus] = React.useState<string>("loaded");

  const fileTypeString = React.useMemo(() => {
    const temp = file.type.split("/").pop();
    if (temp === "mpeg") return "MP3";
    else return temp?.toUpperCase();
  }, [file.type]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <audio
        src={audioState.src}
        ref={audioRef}
        onLoadedData={(e) => {
          setLength(e.currentTarget.duration);
        }}
        onPlay={(e) => {
          setStatus("play");
        }}
        onPause={(e) => {
          setStatus("pause");
        }}
        onEnded={() => setStatus("end")}
        onTimeUpdate={(e) => {
          setPercentage(e.currentTarget.currentTime);
        }}
      />
      <div
        style={{
          width: "200px",
          height: "200px",
          background: "#2222",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          position: "relative",
        }}
      >
        {upPercentage && (
          <div
            style={{
              position: "absolute",
              background: "#fffa",
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                background: "#fff",
                height: "20px",
                borderRadius: "1rem",
                border: "1px solid #2224",
                width: "90%",
                padding: "2px",
                overflow: "clip",
              }}
            >
              <div
                className="progress-bar"
                style={{
                  height: "100%",
                  width: `${upPercentage * 100}%`,
                  borderRadius: "1rem",
                }}
              />
            </div>
          </div>
        )}

        <AudioIconFile color="white" width={100} height={100} />
        <h2 style={{ color: "white", userSelect: "none" }}>{fileTypeString}</h2>
      </div>
      <p>
        <b>{file.name}</b>, {formatBytes(file.size)}
      </p>
      <div
        style={{
          width: 450,
          display: "flex",
          borderRadius: 10,
          paddingInline: 10,
          background: "#2226",
          alignItems: "center",
          color: "#fff",
          fontSize: ".9rem",
          justifyContent: "space-between",
        }}
      >
        <button
          style={{
            ...playerBtn,
          }}
          disabled={percentage === 0}
          onClick={() => {
            if (audioRef.current) {
              audioRef.current.currentTime = 0;
              audioRef.current.pause();
            }
          }}
        >
          <Player.Stop />
        </button>

        <button
          style={playerBtn}
          onClick={() => {
            if (audioRef.current?.paused) {
              audioRef.current?.play();
            } else audioRef.current?.pause();
          }}
        >
          {status === "end" && percentage !== 0 ? (
            <Player.Replay />
          ) : status === "play" ? (
            <Player.Pause />
          ) : (
            <Player.Play />
          )}
        </button>
        <p
          style={{
            padding: 0,
            margin: 0,
            flexGrow: 1,
            whiteSpace: "nowrap",
          }}
        >
          {secondsParser(percentage) + " / " + secondsParser(length)}
        </p>

        <input
          type="range"
          step={0.01}
          className="timeline"
          max={audioRef.current?.duration}
          value={percentage}
          onChange={async (e) => {
            if (audioRef.current)
              audioRef.current.currentTime = e.target.valueAsNumber;
          }}
          style={{}}
        />

        <br />
        <input
          style={{ flex: 1, minWidth: "4rem" }}
          type="range"
          max={100}
          min={0}
          value={vol}
          onChange={(e) => setVol(e.target.valueAsNumber)}
        />
      </div>
    </div>
  );
};

export default AudioPreview;

export function formatBytes(bytes: number, decimals = 2) {
  if (!+bytes) return "0 Bytes";

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
}

export const secondsParser: (s: number) => string = (s) => {
  const min = Math.floor(s / 60);
  const sec = s % 60;
  return min + ":" + Math.ceil(sec).toString().padStart(2, "0");
};

const playerBtn: React.CSSProperties = {
  textAlign: "center",
  padding: 0,

  lineHeight: 0,
  fontSize: "1.5rem",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  minWidth: 30,
  height: 30,
  border: "none",
};
